import _isEmpty from 'lodash/isEmpty';
import { VALUE_TYPES_REGEXP } from './constants';

export const validateValueType = (valueType, value) => {
  if (_isEmpty(value)) {
    return true;
  }

  const regexp = VALUE_TYPES_REGEXP[valueType];
  if (regexp) {
    return regexp.test(value);
  }

  return true;
};